var productionMode = false;
const urlStart = 'https://sahmoil-dash2.ahm.to';

export default {productionMode , urlStart};
